import Drawer, { Props as DrawerProps } from '../../../../../../components/Drawer';
import TileDrawerStepper from '../../../../../shared/TileDrawerStepper';
import DrawerHeader from './DrawerHeader';
import ReusePollSteps, { Steps } from './ReusePollSteps';

export interface ReusePollDrawerProps extends Pick<DrawerProps, 'open' | 'onClose'> {}

const ReusePollDrawer = ({ open, onClose }: ReusePollDrawerProps) => {
  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <TileDrawerStepper header={<DrawerHeader />} steps={Steps}>
        {({ currentStep, goToNextStep }) => (
          <ReusePollSteps currentStep={currentStep} goToNextStep={goToNextStep} />
        )}
      </TileDrawerStepper>
    </Drawer>
  );
};

export default ReusePollDrawer;
